/**
 * Ürün görme hakları (owner 2026-10-28): rolde "Ana Liste ürünlerini gör"
 * (`see_list_products`) ve "Liste Dışı ürünleri gör" (`see_offlist_products`).
 * Rolde yazılmamışsa Evet. Firma rolündeki `user_rights` ürün görmeyi açmaz
 * (owner 2026-10-29): kullanıcı yönetimi açık ama ürünü kısıtlı rol kurulabilir.
 * Asıl süzgeç backend'de (`services/product_rights.py`); burası yalnız menüyü
 * ve sayfa yolunu gizler.
 */
type Permissions = Record<string, unknown> | null | undefined;

export interface ProductRights {
  list: boolean;
  offList: boolean;
}

export function productRights(perms: Permissions): ProductRights {
  const p = perms && !Array.isArray(perms) ? perms : {};
  return {
    list: p.see_list_products !== false,
    offList: p.see_offlist_products !== false,
  };
}

/** Ürün Listesi menüsü ve ürün sayfaları: en az bir ürün türü görülebiliyor mu. */
export function canSeeAnyProduct(perms: Permissions): boolean {
  const r = productRights(perms);
  return r.list || r.offList;
}
